import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-electric-steel mx-auto mb-4"></div>
        <h1 className="text-2xl font-bold text-charcoal-ink mb-4">Verifying Credential</h1>
        <p className="text-warm-slate">Please wait while we verify the credential...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner; 